export default __webpack_public_path__ + "093384d.png";